import type { OrderListItem } from "../../api/orders";

type OrderStatus = OrderListItem["status"];

// Палитра по умолчанию из Tailwind: у витрины нет своих success/danger-токенов
// (её цвета приходят из темы Telegram и акцента магазина, tailwind.config.ts) —
// в отличие от frontend/admin, где такие токены есть.
const BADGE_CLASSES: Record<OrderStatus, string> = {
  new: "bg-blue-100 text-blue-700",
  confirmed: "bg-sky-100 text-sky-700",
  shipped: "bg-amber-100 text-amber-700",
  done: "bg-green-100 text-green-700",
  canceled: "bg-red-100 text-red-700",
};

interface OrderStatusBadgeProps {
  status: OrderStatus;
  label: string;
}

/** OrderStatusBadge — цветной бейдж статуса заказа (docs/07-miniapp-ux.md §2.7). */
export function OrderStatusBadge({ status, label }: OrderStatusBadgeProps) {
  return <span className={`rounded-full px-2 py-1 text-xs ${BADGE_CLASSES[status]}`}>{label}</span>;
}
